// @ts-expect-error is being used to ignore the dynamic imports that are being replaced by WebPack NormalModuleReplacementPlugin

import QuestionSampleRoot from "./QuestionSampleRoot-APP_CLIENT.styled";

export default QuestionSampleRoot;
